import Vue from 'vue'
import Vuex from 'vuex'
import sortBy from 'lodash-es/sortBy'

Vue.use(Vuex);

export default {
  namespaced: true,

  state: () => {
    return {};
  },

  actions: {
    async getFleet(store, fleetId) {
      let response = await store.dispatch(
        'apiRequest',
        {
          method: 'get',
          apiUrl: `/fleet/${fleetId}`,
          // data: undefined,
        },
      );

      if(response.error) {
        console.log('api error', response);
        return null;
      }

      if(!response.data.vessels) {
        response.data.vessels = [];
      }

      return response.data;
    },

    async deleteFleet(store, fleetId) {
      let response = await store.dispatch(
        'apiRequest',
        {
          method: 'delete',
          apiUrl: `/fleet/${fleetId}`,
          data: undefined,
        },
      );

      if(response.error) {
        console.log('api error', response);
        return null;
      }
      return response;
    },

    async createFleet(store, parameters) {
      let response = await store.dispatch(
        'apiRequest',
        {
          method: 'post',
          apiUrl: '/fleet',
          data: parameters,
        },
      );

      if(response.error) {
        console.log('api error', response);
        return null;
      }
      return response;
    },

    async renameFleet(store, parameters) {
      // { fleetId: "...", fleetName: "New name" }
      let response = await store.dispatch(
        'apiRequest',
        {
          method: 'post',
          apiUrl: '/fleet/rename',
          data: parameters,
        },
      );

      if(response.error) {
        console.log('api error', response);
        return response;
      }
      return response.data;
    },

    async copyFleet(store, fleetId) {
      let response = await store.dispatch(
        'apiRequest',
        {
          method: 'post',
          apiUrl: `/fleet/${fleetId}/copy`,
          data: undefined,
        },
      );

      if(response.error) {
        console.log('api error', response);
        return response;
      }
      return response.data;
    },

    async getFleets(store, parameters) {
      let response = await store.dispatch(
        'apiRequest',
        {
          method: 'get',
          apiUrl: '/fleet',
          data: parameters,
        },
      );

      if(response.error) {
        console.log('api error', response);
        return null;
      }
      return sortBy(response.data.fleets, ['fleet_name']);
    },

    async searchVessels(store, searchString) {
      let response = await store.dispatch(
        'apiRequest',
        {
          method: 'get',
          apiUrl: '/vesselsearch',
          data: {
            imo_search_string: searchString,
          },
        },
      );

      if(response.error) {
        console.log('api error', response);
        return null;
      }
      return response.data.vessels || [];
    },



    async addVessel(store, {fleetId, imo}) {
      let response = await store.dispatch(
        'apiRequest',
        {
          method: 'put',
          apiUrl: `/fleet/${fleetId}/vessels/${imo}`,
          // data: undefined,
        },
      );

      if(response.error) {
        console.log('api error', response);
        return null;
      }
      return response.data.vessels;
    },

    async deleteVessel(store, {fleetId, imo}) {
      let response = await store.dispatch(
        'apiRequest',
        {
          method: 'delete',
          apiUrl: `/fleet/${fleetId}/vessels/${imo}`,
          // data: undefined,
        },
      );

      if(response.error) {
        console.log('api error', response);
        return null;
      }
      return response.data.vessels;
    },

    async apiRequest(store, parameters) {
      // here you can override common API request parameters for this api module
      // for example:
      // parameters: {...parameters, baseUrl: process.env.VUE_APP_BETA_API_URL},
      return store.dispatch(
        'api/apiRequest',
        {...parameters, baseUrl: process.env.VUE_APP_BETA_API_URL_V2},
        { root: true },
      );
    },

  },
}
